import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=8a564b24&scoped=true&lang=pug&"
import script from "./SchoolInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfo.vue?vue&type=style&index=0&id=8a564b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a564b24",
  null
  
)

component.options.__file = "SchoolInfo.vue"
export default component.exports